import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import StateManagedSelect from "react-select";
import { SubmitButton, CheckBox } from "../../components/Input";
import { API_URL } from "../../config";
import { showToast } from "../../components/toast";
import LoadingSpinner from "../../components/LoadingSpinner";

const providerOptions = [
    { value: 1, label: "Meta WhatsApp" },
    { value: 2, label: "Razorpay" },
    { value: 3, label: "Stripe" },
    { value: 4, label: "SMTP" },
    { value: 5, label: "Firebase" },
];

const BotsenseConfig = () => {
    const navigate = useNavigate();
    const { id } = useParams(); // 👈 if present = edit
    const token = localStorage.getItem("authToken");

    const [loading, setLoading] = useState(false);
    const [provider, setProvider] = useState(null);
    const [extraConfig, setExtraConfig] = useState("{}");

    const [formData, setFormData] = useState({
        api_token: "",
        phone_number_id: "",
        base_url: "",
        is_active: 1,
    });

    /* =======================
       FETCH BY ID (EDIT)
    ======================= */
    const fetchConfigById = async () => {
        setLoading(true);
        try {
            const res = await axios.get(
                `${API_URL}api-config/by-id/${id}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            const data = res.data.data;

            setProvider(
                providerOptions.find((p) => p.value === data.provider) || null
            );

            setFormData({
                api_token: data.api_token || "",
                phone_number_id: data.phone_number_id || "",
                base_url: data.base_url || "",
                is_active: data.is_active ?? 1,
            });

            setExtraConfig(JSON.stringify(data.extra_config || {}, null, 2));
        } catch (err) {
            showToast.error("Failed to load configuration");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (id) fetchConfigById();
    }, [id]);

    /* =======================
       HANDLERS
    ======================= */
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!provider) {
            showToast.error("Please select provider");
            return;
        }

        let parsedExtraConfig;
        try {
            parsedExtraConfig = JSON.parse(extraConfig);
        } catch {
            showToast.error("Extra config must be valid JSON");
            return;
        }

        const payload = {
            provider: provider.value,
            api_token: formData.api_token,
            phone_number_id: formData.phone_number_id,
            base_url: formData.base_url,
            extra_config: parsedExtraConfig,
            is_active: Number(formData.is_active),
        };

        try {
            const url = id
                ? `${API_URL}api-config/${id}`
                : `${API_URL}api-config`;

            const method = id ? "put" : "post";

            const res = await axios({
                method,
                url,
                data: payload,
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });

            showToast.success(res.data.message || "Saved successfully");
            navigate("/Settings/apiconfig");
        } catch (err) {
            showToast.error(err.response?.data?.message || "Save failed");
        }
    };

    if (loading) return <LoadingSpinner />;

    /* =======================
       UI
    ======================= */
    return (
        <div id="page-container">
            <div id="content">
                <div className="panel panel-default">
                    <form onSubmit={handleSubmit}>
                        <div className="panel-heading">
                            <span className="panel-title">
                                {id ? "Edit" : "Add"} BotSense Configuration
                            </span>
                        </div>

                        <div className="panel-body row">
                            {/* Provider */}
                            <div className="col-md-6">
                                <label>Provider</label>
                                <StateManagedSelect
                                    options={providerOptions}
                                    value={provider}
                                    onChange={setProvider}
                                    placeholder="Select Provider"
                                />
                            </div>

                            {/* API Token */}
                            <div className="col-md-6">
                                <label>API Token</label>
                                <textarea
                                    name="api_token"
                                    className="form-control"
                                    rows="3"
                                    value={formData.api_token}
                                    onChange={handleChange}
                                />
                            </div>

                            {/* Phone Number ID */}
                            <div className="col-md-6">
                                <label>Phone Number ID</label>
                                <input
                                    name="phone_number_id"
                                    className="form-control"
                                    value={formData.phone_number_id}
                                    onChange={handleChange}
                                />
                            </div>

                            {/* Base URL */}
                            <div className="col-md-6">
                                <label>Base URL</label>
                                <input
                                    name="base_url"
                                    className="form-control"
                                    value={formData.base_url}
                                    onChange={handleChange}
                                />
                            </div>

                            {/* Extra Config */}
                            <div className="col-md-12">
                                <label>Extra Config (JSON)</label>
                                <textarea
                                    className="form-control"
                                    rows="5"
                                    value={extraConfig}
                                    onChange={(e) => setExtraConfig(e.target.value)}
                                />
                            </div>

                            {/* Active */}
                            <div className="col-md-3">
                                <div className="form-group" style={{ marginTop: "25px" }}>
                                    <CheckBox
                                        label="Active"
                                        checked={formData.is_active === 1}
                                        onChange={(e) =>
                                            setFormData((prev) => ({
                                                ...prev,
                                                is_active: e.target.checked ? 1 : 0,
                                            }))
                                        }
                                    />
                                </div>
                            </div>


                            {/* Submit */}
                            <div className="col-md-12">
                                <SubmitButton
                                    pageBack="/Settings/apiconfig"
                                    handleSubmit={handleSubmit}
                                />
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default BotsenseConfig;
